module.exports = __webpack_public_path__ + "img/b5.c468d9ad.png";